import { PureComponent } from 'react'
import classNames from 'classnames'

import Overlay from './components/Overlay'
import ButtonSocial from './components/ButtonSocial'
import ButtonTrigger from './components/ButtonTrigger'
import socialMediaList from './components/socialMediaList'

class ShareButtons extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      overlayIsVisible: false,
      shareListIsVisible: false
    }

    this.pageURL = window.location.href
  }

  toggleOverlay = () => {
    this.setState(prevState => ({
      overlayIsVisible: !prevState.overlayIsVisible,
      shareListIsVisible: !prevState.shareListIsVisible
    }))
  }

  checkBlackList = () => {
    const blackList = [
      '/meus-pedidos',
      '/meus-projetos',
      '/minha-conta',
      '/minhas-listas-de-desejo',
      '/minhas-listas-de-favorito'
    ]

    return blackList.includes(window.location.pathname)
  }

  renderButtons = buttonList =>
    buttonList.map((button, index) => (
      <li key={`${index}-${button.name}`} className="share-button-item">
        <ButtonSocial
          name={button.name}
          url={`${button.url}${this.pageURL}`}
        />
      </li>
    ))

  render () {
    const { overlayIsVisible, shareListIsVisible } = this.state

    const shareListClass = classNames(
      'share-button-list',
      {
        active: shareListIsVisible
      }
    )

    const titleClass = classNames(
      'share-button-title',
      {
        hidden: shareListIsVisible
      }
    )

    const shareContentClass = classNames(
      'share-button-content',
      {
        active: shareListIsVisible
      }
    )

    if (this.checkBlackList()) {
      return null
    }

    return (
      <div className="share-buttons-component">
        <Overlay
          isVisible={overlayIsVisible}
          handleClick={this.toggleOverlay}
        />

        <ButtonTrigger trigger={this.toggleOverlay} active={shareListIsVisible} />

        <div className={shareContentClass}>
          <ul className={shareListClass}>
            {this.renderButtons(socialMediaList)}
          </ul>
        </div>
      </div>
    )
  }
}

export default ShareButtons
